<div class="attachment">
  <div class="close" mat-dialog-close>
    <mat-icon>close</mat-icon>
  </div>
  <img [src]="data.url" alt="">
</div>